import React, { useState, useEffect } from 'react';
import Login from '../components/Login';
import Upload from '../components/Upload';
import Results from '../components/Results';
import SEO from '../components/SEO';

const Home = ({ isLoggedIn, onLogin }) => {
  const [compressedFile, setCompressedFile] = useState(null);

  const handleCompressionComplete = (file) => setCompressedFile(file);

  return (
    <div className="section-container w-full h-full flex flex-col items-center justify-center animate-fade-in-up px-4" style={{ animationDelay: '0.1s' }}>
      <SEO 
        title="Next-Gen Image Optimization"
        description="Optimize images with COMPRESSAI Engine for ultra-fast performance, batch ZIP compression, and 81%+ reduction in size."
        keywords={['image optimization', 'batch compression', 'zip image compression', 'lossless image optimization', 'compressai engine']}
      />
      {!isLoggedIn ? (
        <div className="flex flex-col items-center justify-center w-full">
          <Login onLogin={onLogin} />
        </div>
      ) : (
        <div className="w-full flex flex-col items-center gap-6 py-4 animate-fade-in-up overflow-y-auto max-h-full">
          <Upload onCompressionComplete={handleCompressionComplete} />
          {compressedFile && (
            <div className="w-full max-w-4xl animate-fade-in-up">
              <Results file={compressedFile} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Home;
